import { useEffect, useRef, useState } from 'react'
import EnterpriseIcon, { ProfileIcon } from '@enterprise-ui/icons'
import { SIGN_OUT } from '../../../constants'
import {
  DropdownButton,
  DropdownContainer,
  DropdownItem,
  DropdownMenu,
  UserInfo,
} from './styles/ProfileDropdown'

interface Props {
  userName: string
  onSignOut: () => void
}

const ProfileDropdown = ({ userName, onSignOut }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return

    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen])

  const handleSignOut = () => {
    onSignOut()
    setIsOpen(false)
  }

  return (
    <DropdownContainer ref={containerRef}>
      <DropdownButton
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <EnterpriseIcon icon={ProfileIcon} />
        <span>{userName}</span>
      </DropdownButton>

      <DropdownMenu isOpen={isOpen} role="menu">
        <UserInfo>{userName}</UserInfo>
        <DropdownItem onClick={handleSignOut} role="menuitem">
          {SIGN_OUT}
        </DropdownItem>
      </DropdownMenu>
    </DropdownContainer>
  )
}

export default ProfileDropdown
